import { SecondaryColor } from "@resource/common";
import React, { CSSProperties } from "react";
import { Theme } from "types/legacy";
import createOrgPrimaryLightColor from "utils/createOrgPrimaryLightColor";

function OrganizationThemeWrapper({
  theme,
  className,
  children,
}: {
  theme: Theme;
  className?: string;
  children: React.ReactNode;
}) {
  const orgPrimaryLightColor = createOrgPrimaryLightColor(theme.primaryColor);

  const orgSecondaryColor =
    theme.secondaryColor && theme.secondaryColor !== "#ffffff"
      ? theme.secondaryColor
      : SecondaryColor;

  return (
    <div
      style={
        {
          "--org-primary-color": theme.primaryColor,
          "--org-primary-light-color": orgPrimaryLightColor,
          "--org-secondary-color": orgSecondaryColor,
        } as CSSProperties
      }
      className={className}
    >
      {children}
    </div>
  );
}

export default OrganizationThemeWrapper;
